import { useFirebaseProviders } from 'modules/Firebase/FirebaseProvider';
import { useCollection } from 'react-firebase-hooks/firestore';

export default function useAboutDogsData() {
    const { firestore } = useFirebaseProviders();
    return useCollection(firestore.collection('dogs').where('isOnHomePage', '==', true), {
        snapshotListenOptions: { includeMetadataChanges: true },
        idField: 'id',
    });
}
